var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandWithHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.825 19.25V14c-.031-.48-.363-1.443-1.443-1.443-1.351 0-1.632.702-1.632 1.072v1.217-3.129c-.047-.336-.424-1.008-1.565-1.008-1.14 0-1.492.811-1.526 1.217v2.92-4.971c-.094-.313-.54-.939-1.57-.939-1.285 0-1.53.556-1.565.939-.028.306-.011 3.442 0 4.971V4.59c-.027-.382-.389-1.147-1.612-1.147-1.224 0-1.6.765-1.636 1.147v13.872l-2.812-4.832c-.418-.333-1.478-.724-2.368.37-.89 1.094-.017 1.854.175 2.41l4.135 6.919c.863 1.17 3.195 3.198 5.684 3.198 3.7 0 7.073-2.027 7.735-7.277zM6.63 4.92l3.346-3.195m0 0H6.63m3.346 0V4.92M4.879 6.898 1.57 10.169m0 0H4.88m-3.309 0V6.898",
    stroke: "#000",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandWithHand);
export default __webpack_public_path__ + "static/media/expandWithHand.358e102949a988463f230c1be2f92f19.svg";
export { ForwardRef as ReactComponent };